module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-med.54a8a9ed.jpg";